import * as React from 'react'
import { SVGProps } from 'react'
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M13.625 8H2.375" stroke="#1C1915" />
  </svg>
)
export default SvgMinus
